import { FeatureConfiguration } from "..";
import { groupTabHistoryDataReducer } from "./reducers";

export * from "./types";
export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.groupTabHistoryData = groupTabHistoryDataReducer;
}
